// extracted by mini-css-extract-plugin
export default {"clip-not-allowed":"clip-not-allowed__awdhq","clip-not-allowed__reason":"clip-not-allowed__reason__awdhq"};